// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"y7dcvpwqRPMMYWj6"};